import $ from "jquery";
import _ from "lodash";

const utils = {
    /**
     * Get the width of a scrollbar in the browser.
     *
     * @return {Integer} The width of a scrollbar in the browser.
     */
    getScrollbarWidth: _.once(function () {
        // Create the measurement node
        const scrollDiv = $("<div/>")
            .css({
                width: "100px",
                height: "100px",
                overflow: "scroll",
                position: "absolute",
                top: "-9999px",
            })
            .appendTo(document.body)[0];

        // Get the scrollbar width
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        // Delete the DIV
        $(scrollDiv).remove();

        return scrollbarWidth;
    }),
};

export default utils;
